 import React from 'react'
import { useEffect, useState, useRef, createRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import ComFunction from "../components/ComFunction";
import AGFunction from "../components/AGFunction";
import MasterBase from "../components/MasterLayout";
import EntryGridAr from "../components/EntryGridAr";
import EntrySetting from "../components/EntrySetting";
import EntryRemarks from "../components/EntryRemarks";
import EntryImages from "../components/EntryImages";
import EntryFiles from "../components/EntryFiles";
import EntryBase from "../components/EntryBase";
import Headline from "../components/Headline";
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import {
    isEmpty, getglobaldata, CellType, Getstorage, Savestorage, DeepCopy, getWindowDimensions, setglobaldata, getformid,
    getcontroller, getsubkey, initializedata, isEnabled, Loadstorage, NumConv, GetRound, GetDesitRound, DicVal
} from '../modules/appLibrary';
import { cfFileUpload, cfNewUploadFile, cfMargeUploadFiles } from '../modules/commodule';
import { setimagelist } from '../modules/imagedlgstore';
import { arrayMove } from 'react-sortable-hoc';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import Chip from '@material-ui/core/Chip';
import { styled } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import EntryLayout from '../components/EntryLayout';
import { changestatus, listtabs, entrytriggercall, setgridlist, listoption, rerendergrid } from '../modules/formstore';
import { setentrypanel, addentrylayout, setentrylayout, setentrystartup} from '../modules/toolpanelstore';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
    listStyle: 'none'
}));

export const RawSupplyInBulk = props => {

    const panelsdef = [];
    const G_id = { BASE: "0", IMAGE: "pic", FILE: "file", NB: "nb", PL:"pl", "TOTAL":"1", MEI:"2", MEIHED:"ex2"}
    const formid = getformid("RawSupplyInbulk", props.location.search);
    const controller = getcontroller("RawSupplyInbulk", props.location.search);
    const subkey = getsubkey(props.location.search);

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const staff = useSelector(state => state.user.accctl);
    const menuinfo = useSelector(state => state.form.menuinfo);
    const mainlayout = useSelector(state => state.toolpnl.layouts_et);
    const mainprelayout = useSelector(state => state.toolpnl.prelayout_et);
    const maininitlayout = useSelector(state => state.toolpnl.initlayout_et);

    const AGRef = useRef();
    const fnc = useRef();
    const EntrybodyRef = useRef(null);
    const locationstate = useRef(null);    //遷移State
    const CELLTYPE = CellType();

    const formstatus = useSelector(state => state.form.status);
    const entrylock = useSelector(state => state.form.entryformlock);
    const [panel, setpanel] = useState(panelsdef);
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const [columninfo, setcolumninfo] = useState(null);     //全カラム情報
    const [columns, setcolumns] = useState(null);
    const [edittingcode, setedittingcode] = useState(null);
    const [textfieldsall, settextfieldsall] = useState([]);
    const [textfields, settextfields] = useState([]);
    const [extextfields, setextextfields] = useState([]);
    const [layoutlock, setlayoutlock] = useState(false);
    const [sectionclose, setsectionclose] = useState(false);
    const [update, setUpdata] = useState(false);
    const [selectssdno, setselectssdno] = useState("");
    const [ssdnos, setssdnos] = useState(null);
    const [isDragActive, setIsDragActive] = useState(false);
    const gridlist = useSelector(state => state.form.gridlist);


    const dispatch = useDispatch();
    const search = useLocation().search;
    const AGFunc = React.forwardRef(AGFunction);
    const ComFunc = React.forwardRef(ComFunction);
    const scrollRef = useRef(null);
    const baseref = useRef();

    const gridapiRefs = useRef([]);
    const gridcolapiRefs = useRef([]);
    const griddataRefs = useRef([]);
    const gridcolRefs = useRef([]);

    //データ
    const entrydataRef = useRef(null);
    const imageRef = useRef(null);
    const fileRef = useRef(null);         //ファイル
    const siiressdRef = useRef(null);     //仕入に存在する加工指示番号
    const detailRef = useRef(null);       //加工指示データ

    function handleChange(e, newValue) {
        if(!isEmpty(selectssdno)) storeRowData();
        DispInfoSelectSSD(newValue, detailRef.current);
    };
    function DispInfoSelectSSD(newValue, data) {
        setselectssdno(newValue);
        var target = ChooseSSDRow(newValue, data);
        //海外区分が海外の場合のみInvoiceNo,edaは編集可
        changecelllock(["ZSK_INVOICENO", "ZSK_INVOICEEDA"], DicVal(target[0], "ZSK_KAIGAIKBN", "") !== '2');

        entrydataRef.current = { ...entrydataRef.current, ...target[0] };
        SetGridData(G_id.MEI, target);
        fnc.current.entryrerender();
        function ChooseSSDRow(ssdno, data) {
            var target = data.filter(item => item.ZSK_SSDNO === ssdno);
            target.forEach((d) => { 
                //存在しない項目を補完
                extextfields.forEach((f) => {
                    if (!Object.hasOwn(d, f.columnid)) d[f.columnid] = "";
                });
            });
            return target;
        }
    }

    function SetGridData(panel, data) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        griddataRefs.current[gidx].current = data;
    }
    function GridData(panel) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return null;
        return griddataRefs.current[gidx].current;
    }
    function SetGridColDef(panel, coldef) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        gridcolRefs.current[gidx].current = coldef;
    }
    function GridColDef(panel) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        return gridcolRefs.current[gidx].current;
    }
    function SetGridApi(panel, api) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        gridapiRefs.current[gidx].current = api;
    }
    function GridApi(panel) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return null;
        return gridapiRefs.current[gidx].current;
    }
    function SetGridColApi(panel, api) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        gridcolapiRefs.current[gidx].current = api;
    }
   function GridColApi(panel) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return null;
        return gridcolapiRefs.current[gidx].current;
    }
    function GridRefs(panel) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return null;
        if (isEmpty(griddataRefs.current[gidx]) || isEmpty(gridcolRefs.current[gidx])) return null;
        return {
            dataRef: griddataRefs.current[gidx],
            columnRef: gridcolRefs.current[gidx]
        };
    }
    function rerender() {
        setUpdata(update ? false : true);
    }
    function onDragEnter(e) {
        if (entrylock) return;
        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            setIsDragActive(true);
        }
    };
    //主キー取得
    function primarykey() {
        if (isEmpty(columninfo)) return "";
        if (!columninfo.some(e => e.primarykey)) return "";
        return columninfo.find(e => e.primarykey).columnid;
    }
    //項目名取得
    function nametocolumn(name) {
        if (isEmpty(columninfo)) return "";
        if (!columninfo.some(e => e.columnid.indexOf(name) !== -1)) return "";
        return columninfo.find(e => e.columnid.indexOf(name) !== -1).columnid;
    }

    useEffect(() => {
        if (isEmpty(corpkey) || isEmpty(account)) return;

        //ListTabを取得
        fnc.current.postaxios('common/GetEntryPanels', { "panels": panelsdef, "controller": controller, "subkey": subkey },
            {
                onSuccess: function (data) {
                    setpanel(data.panels);
                    dispatch(setentrypanel({
                        layouts: data.layouts, prelayout: data.prelayout,
                        initlayout: data.initlayout.length === 0 ? " " : data.initlayout,
                        fitColumn: data.fitColumn
                    }));
                    setcolumninfo(data.colinfo);
                    setcolumns(data.columns);
                    let fields = data.colinfo.filter(e => e.logpid === G_id.BASE);
                    settextfieldsall(fields);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    setextextfields(data.columns.filter(e => e.logpid === G_id.MEIHED));
                    fnc.current.initMaster(data.master);

                    let idx = 0;
                    let glist = [];
                    data.panels.filter(e => e.grid).forEach(function (panel) {
                        gridapiRefs.current[idx] = createRef();
                        gridcolapiRefs.current[idx] = createRef();
                        griddataRefs.current[idx] = createRef();
                        gridcolRefs.current[idx] = createRef();
                        glist.push({ id: panel.id, type: panel.type, index: idx });
                        idx++;
                    });

                    dispatch(setgridlist(glist));

                    if (data.prelayout) {   //レイアウト復元
                        RestoreLayout(data.panels, fields);
                    }

                    //遷移state取得
                    let state = props.location.state;   //history.push
                    if (isEmpty(state) && !isEmpty(window.history.state)) {
                        if ("status" in window.history.state) {
                            //go back
                            state = window.history.state;
                        }
                    }
                    let key = search.split("key=")[1];
                    if (isEmpty(state) && !isEmpty(key)) {
                        let calldata = Loadstorage(key);
                        state = calldata?.state;  //他画面からの連携情報取得
                    }
                    locationstate.current = state;
                    clearform();
                    dispatch(changestatus("NEW FORM"));
                    //非表示コマンド
                    var hidemenu = [{ status: "NEW FORM", cmd: "フィールドクリア" },
                        { status: "ENTRY FORM", cmd: "登録" },
                        { status: "ENTRY FORM", cmd: "再表示" } ]
                    baseref.current.hideMenucmd(hidemenu);
                    fnc.current.wait(false);
               }
            });
    }, [search]);

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (isEmpty(menuinfo.ctrls)) return;
        setlayoutlock(menuinfo.ctrls.indexOf("LOCK2") !== -1);
        setsectionclose(menuinfo.ctrls.indexOf("SECCLOSE") !== -1); //セクションCLOSEボタン
    }, [menuinfo]);

    useEffect(() => {
    }, [formstatus]);

    function TryCallShow() {
        if (isEmpty(locationstate.current)) {
            return;
        }
        let call = true;
        for (let i = 0; i < gridlist.length; i++) {
            if (EmptyPanel(gridlist[i].id, gridlist[i].type)) continue;
            if (isEmpty(GridApi(gridlist[i]))) {
                call = false; break;
            }
        }
        //遷移表示
        if (call) callshow();
    }

    //遷移state状態表示
    function callshow() {
        if (isEmpty(locationstate.current) || !("code" in locationstate.current)) {
            locationstate.current = null;
            return;
        }
        if (locationstate.current.code !== "") {
            Show(undefined, locationstate.current.code)
        } else {
            if (!isEmpty(locationstate.current.acceptno)) {
                AcceptAction(locationstate.current.acceptno, locationstate.current.accepttype);
            }
        }
        locationstate.current = null;   //最初の１度のみ
    }
    //受入処理
    function AcceptAction(value, accepttype) {
        fnc.current.postaxios('rawsupplyinbulk/GetAccept', {
            "keys": [value],
            "colinfo": columninfo,
            "columns": columns,
            "controller": controller,
            "others": { "accepttype": accepttype }
        },
            {
                onSuccess: function (data) {
                    try {
                        ApplyAcceptData(data);
                        rerender();
                        fnc.current.wait(false);
                    } catch (error) {
                        console.log(error);
                        fnc.current.wait(false);
                    }

                },
                errmsg: "処理に失敗しました"
            }
        )
    }

    function ApplyAcceptData(data) {
        if (isEmpty(data)) return;
        if (!isEmpty(data.data)) {
            entrydataRef.current = data.data;
        }
        if (isEmpty(data.detail)) return;
        if (data.keys.length > 0) {
            setssdnos([...data.keys]);
            siiressdRef.current = [...data.keys];
            detailRef.current = data.detail["detail"];
            DispInfoSelectSSD(data.keys[0], data.detail["detail"]);
        }
        for (let i = 0; i < gridlist.length; i++) {
            var rows = data.detail[gridlist[i].type];
            if (isEmpty(rows)) continue;
            SetGridData(gridlist[i], rows);
        }
        //不要列の削除
        switch (DicVal(data.data, "ZSK_ZAIRYOKBN", "")){
            case "1":       //素材
                var removecols = ['ZSKM_ZAISIZECD', 'FZK_SIREFUZOKU_SIZE', 'ZSKM_SIKYUSU', 'ZSKM_SIKYUTANSU', 'TOTALTAN'];
                var coldef = GridColDef(G_id.TOTAL).filter(field => !removecols.includes(field.colId));
                SetGridColDef({ id: G_id.TOTAL, type: "110" }, coldef, coldef, false);
                var coldef = GridColDef(G_id.MEI).filter(field => !removecols.includes(field.colId));
                SetGridColDef({ id: G_id.MEI, type: "120" }, coldef, coldef, false);
                break;
            case "2":       //附属
                var removecols = ['ZSKM_SIKYUTANSU', 'ZSKM_SIKYUMETERSU', 'TOTALTAN'];
                var coldef = GridColDef(G_id.TOTAL).filter(field => !removecols.includes(field.colId));
                SetGridColDef({ id: G_id.TOTAL, type: "110" }, coldef, coldef, false);
                var coldef = GridColDef(G_id.MEI).filter(field => !removecols.includes(field.colId));
                SetGridColDef({ id: G_id.MEI, type: "120" }, coldef, coldef, false);
                break;
            case "3":       //副資材
                var removecols = ['ZSKM_ZAISIZECD', 'FZK_SIREFUZOKU_SIZE', 'ZSKM_SIKYUTANSU', 'ZSKM_SIKYUMETERSU', 'TOTALTAN'];
                var coldef = GridColDef(G_id.TOTAL).filter(field => !removecols.includes(field.colId));
                SetGridColDef({ id: G_id.TOTAL, type: "110" }, coldef, coldef, false);
                var coldef = GridColDef(G_id.MEI).filter(field => !removecols.includes(field.colId));
                SetGridColDef({ id: G_id.MEI, type: "120" }, coldef, coldef, false);
                break;
        }
        if (data.keys.length === 0) {
            fnc.current.infomsg("加工指示を選択し入力を開始してください");
        }
    }
    //編集ロック
    function changecelllock(columnids, locked) {
        const updateColumns = (fields) => {
            if (isEmpty(fields) || !Array.isArray(columnids)) return fields;

            let changed = false;
            const newfields = DeepCopy(fields);

            newfields.forEach(field => {
                if (columnids.includes(field.columnid) && field.locked !== locked) {
                    field.locked = locked;
                    changed = true;
                }
            });

            return changed ? newfields : fields;
        };

        setextextfields(prev => updateColumns(prev));
    }

    function onFirstDataRendered(param, panel) {
        SetGridApi(panel, param.api);
        SetGridColApi(panel, param.api);

        TryCallShow();
    }

    //リストレイアウト適用
    function SetLayout(newcol, type) {
        let newfields = DeepCopy(textfields.filter(e=>e.type !==type));
        for (let i = 0; i < newcol.length; i++) {
            let column = textfieldsall.find(e => e.columnid === newcol[i]);
            newfields.push(column);
        }
        settextfields(newfields);
   }

    function showpanel(id, type, show) {
        let newpanel = DeepCopy(panel);
        let p = newpanel.find(e => e.id === id && e.type === type);
        p.hide = !show;
        setpanel(newpanel);
    }
    // スクロール位置を保存する
    function saveScrollPos() {
        scrollRef.current = EntrybodyRef.current.scrollTop;
    }
    // スクロール位置を復元する
    function restoreScrollPos() {
        try{
            if (scrollRef.current) EntrybodyRef.current.scrollTop = scrollRef.current;
        }catch{ }
    }
    //加工指示データ保持
    function storeRowData() {
        var data = AGRef.current.GetDatasource(GridApi(G_id.MEI));
        data.forEach((d) => {
            //支給日、計上日、摘要を反映
            d["ZSK_SIKYUBI"] = entrydataRef.current["ZSK_SIKYUBI"];
            d["ZSK_KEIJYODATE"] = entrydataRef.current["ZSK_KEIJYODATE"];
            d["ZSK_TEKIYO"] = entrydataRef.current["ZSK_TEKIYO"];
        });
        if (!isEmpty(detailRef.current)) {
            var newdata = detailRef.current.filter(e => e["ZSK_SSDNO"] !== selectssdno);
            detailRef.current = [...newdata, ...data];
        }
    }

    function Jump(id, type) {
        let offset = 0;
        var panelid = "basepanel" + type;
        if (id === G_id.IMAGE) panelid = 'imagepanel';
        if (id === G_id.FILE) panelid = 'fileGrid';
        if (id === G_id.NB) panelid = 'remarkspanel' + type;
        if (isEmpty(type)) {
            type = tabletype(id);
        }
        if (panel.some(e => e.id === id && e.type === type && e.grid)) {
            panelid = fnc.current.GridID({ id: id, type: type });
        }
        let elem = document.getElementById(panelid);
        if (isEmpty(elem)) return;
        offset = elem.offsetTop - 50;
        EntrybodyRef.current.scrollTop = offset;
    }


    function MenuAction(action, finallycallback) {
        LayoutSaveStorage();   //現在レイアウト保持
        if (action === 'save') Save(finallycallback);
        if (action === 'delete') Delete(finallycallback);
        if (action === "clear") clearform(true);
        if (action === 'linkfield') {
            let col = textfields.find(e => e.columnid === finallycallback.field && (isEmpty(finallycallback.type)?true:e.type === finallycallback.type));
            if (col === undefined) return;
            if (col.logpid == "0") {    //基本情報
                let key = finallycallback.field + "_" + col.type;
                document.getElementById(key).focus();
                document.getElementById(key).select();
                Jump(G_id.BASE, col.type);
                return;
            }
            let logpid = col.logpid;
            Jump(logpid);
            AGRef.current.SetRowSelect(finallycallback.rowid, finallycallback.field, GridApi({ id: logpid }));
        }
    }
    function Save(finallycallback, nocheck) {
        var newfiles = (formstatus === "ENTRY FORM" ? [] : cfNewUploadFile(imageRef, fileRef)); //v1.4
        if (newfiles.length > 10) {
            fnc.current.warnmsg("新規登録できるアップロードファイル数は10までです。");
            return;
        }
        var detail = {};
        detail["detail"] = detailRef.current;
        const paramdata = {
            "controller": formid,
            "data": entrydataRef.current,
            "detail": detail,
            "images": imageRef.current,
            "files": fileRef.current,
            "colinfo": columninfo,
            "keys": ssdnos,
            "noconfirm": nocheck
        }
        storeRowData();
        fnc.current.postaxios( "rawsupplyinbulk/InsertEntry", paramdata,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.modify(false);
                        dispatch(changestatus("ENTRY FORM"));
                        fnc.current.wait(false);
                        if (!isEmpty(data.note)) {
                            fnc.current.successmsg(data.note);
                        } else {
                            fnc.current.success();
                        }
                        return;
                    }
                    else {
                        if (isEnabled(data.confirm)) {
                            //確認メッセージ
                            var msgs = data.warning.map(e => e.message);
                            fnc.current.confmsg(msgs, () => Save(finallycallback, true));
                        } else {
                            let msg = data.warning.length + "件の制約違反により登録できませんでした。";
                            fnc.current.showwarndescription(msg, data.warning);
                        }
                    }
                    fnc.current.wait(false);
                },
                errmsg: "登録に失敗しました"
            }
        )
    }


    function Show(data, pushcode) {
        let code = "";
        if (data === undefined) {
            code = !isEmpty(pushcode) ? pushcode : edittingcode;
        } else {
            setglobaldata("entryrowdata", data);
            if (data !== null) {
                let pkey = primarykey();
                if (!isEmpty(pkey) && !isEmpty(data[pkey])) {
                    code = data[pkey];
                }
            }
        }
        setedittingcode(code);
        if (isEmpty(columninfo) || isEmpty(code)) return false;
        clearform(code === "");
        LoadData(code);
        return true;
    }

    function LoadData(code) {
        if (isEmpty(code)) return;
        fnc.current.postaxios('rawsupplyinbulk/GetData',
            {
                "code": code,
                "colinfo": columninfo,
                "columns": columns,
                "controller": controller
            },
            {
                onSuccess: function (data) {
                    try {
                        ApplyAcceptData(data);
                        imageRef.current = data.images;
                        fileRef.current = data.files;
                        dispatch(setimagelist(data.images));
                        setedittingcode(code);
                        dispatch(changestatus("ENTRY FORM"));
                        rerender();
                        fnc.current.wait(false);
                    } catch (error) {
                        console.log(error);
                        fnc.current.wait(false);
                    }
                },
                errmsg: "データ読込に失敗しました"
            }
        )
    }

    //入力フィールドクリア
    function clearform(newform) {
        entrydataRef.current = initializedata(textfieldsall, staff);
        imageRef.current = null;
        fileRef.current = null;
        scrollRef.current = null;
        for (let i = 0; i < gridlist.length; i++) {
            SetGridData(gridlist[i], null);
        }

        dispatch(setimagelist([]));
        fnc.current.modify(false);

        if (isEnabled(newform)) {
            //SQL初期値セット
            fnc.current.postaxios("common/GetInitSqlValue", { colinfo: textfieldsall },
            {
                onSuccess: function (data) {
                    for (let key in data.returnData) {
                        var col = textfieldsall.find(e => e.columnid === key);
                        if (!isEmpty(col)) col.initvalue = data.returnData[key];
                    }
                    entrydataRef.current = initializedata(textfieldsall, staff);
                    rerender();
                },
            }, true
            )
        }
    }
    //基本項目設定
    function SetBaseField(type) {
        fnc.current.entrylayoutopen(type);
    }
    //レイアウト復元
    function RestoreLayout(panels, fields) {
        //パネルの並び
        RestorePanel(panels);
        //基本情報
        RestoreBase(fields)
    }
    function RestorePanel(panel) {
        let paneldata = Getstorage(corpkey, account, formid + "panel");
        if (isEmpty(paneldata)) return;
        if (panel.length !== paneldata.length) return;
        for (let i = 0; i < paneldata.length; i++) {
            let item = panel.find(e => e.id === paneldata[i].id && e.type === paneldata[i].type);
            if (isEmpty(item)) return;
            paneldata[i].name = item.name;
            paneldata[i].name2 = item.name2;
            paneldata[i].abbr = item.abbr;
        }
        setpanel(paneldata);
    }
    function RestoreBase(fields) {
        const baseinfo = Getstorage(corpkey, account, fnc.current.statusKey(G_id.BASE, "", formid));
        if (isEmpty(baseinfo)) return;
        let newdata = [];
        for (let i = 0; i < baseinfo.length; i++) {
            let item = fields.find(e => e.table === baseinfo[i].table && e.columnid === baseinfo[i].columnid);
            if (isEmpty(item)) return;
            newdata.push(item);
        }
        settextfields(newdata);
    }
    //レイアウト保持
    function LayoutSaveStorage() {
        //列情報保存
        for (let i = 0; i < gridlist.length; i++) {
            AGRef.current.SaveColState(fnc.current.statusKey(gridlist[i].id, gridlist[i].type, formid), EmptyPanel(gridlist[i].id) ? null : GridColApi({id:gridlist[i].id, type:gridlist[i].type}));
        }
        //基本情報保存
        Savestorage(corpkey, account, fnc.current.statusKey(G_id.BASE, "", formid), textfields);
        //パネルの表示/非表示および並び
        Savestorage(corpkey, account, formid + "panel", panel);
    }

    //レイアウト登録
    function SaveLayout(layoutid) {
        let setbase = false;
        let coldef = [];
        for (let p = 0; p < panel.length; p++) {
            var cols = [];
            if (panel[p].id === G_id.BASE) {
                if (setbase) break;
                let fds = textfields.filter(x => !x.hide);
                for (let f = 0; f < fds.length; f++) {
                    coldef.push({
                        headerName: fds[f].columnnm, table: fds[f].table, field: fds[f].columnid, width: fds[f].width,
                        type: fds[f].type
                    });
                }
                setbase = true;
            } else {
                cols = AGRef.current.GetshownColDef(GridColApi({ id: panel[p].id })); 
            }
            for (let i = 0; i < cols.length; i++) {
                let col = DeepCopy(cols[i]);
                col.type = tabletype(panel[p].id);
                coldef.push(col);
            }
        }
        fnc.current.postaxios('common/SaveLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
                coldef: coldef,
                panels: panel
            },
            {
                onSuccess: function (data) {
                    let newlayout = { value: layoutid, label: layoutid };
                    dispatch(addentrylayout(newlayout));
                    fnc.current.success();
                    fnc.current.wait(false);
               },
            }
        )
    }
    //レイアウト削除
    function DeleteLayout(layoutid) {
        fnc.current.postaxios('common/DeleteEntryLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    let newlayout = mainlayout.filter(function (val) { return val.value !== layoutid; });
                    dispatch(setentrylayout(newlayout));
                    if (data.request !== maininitlayout)
                        dispatch(setentrystartup({
                            prelayout: mainprelayout,
                            initlayout: " ",
                            fitColumn: false
                        }));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    //レイアウト呼び出し
    function CallLayout(layoutid) {
        fnc.current.postaxios('common/LoadLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    //列情報初期化
                    for (let i = 0; i < gridlist.length; i++) {
                        var type = gridlist[i].type;
                        var coldef = AGRef.current.createColDef(columninfo.filter(e => e.type === type), data.columns.filter(e => e.type === type), false);
                        if (coldef.length === 0) continue;
                        SetGridColDef({ id: gridlist[i].id, type: gridlist[i].type }, coldef);
                    }
                    setpanel(data.panels);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    setcolumns(data.columns);
                    fnc.current.wait(false);
                },
            }
        )
    }

    //加工指示選択
    function showssdlist() {
        fnc.current.searchlistopen({
            label: "加工指示",
            multiple: true,
            rowmode: false,
            data: { dataid: 'FD_SSD:RSBK', datatype: CELLTYPE.MASTERCODE, initial: true },
            rowdata: entrydataRef.current,
            rowid: null,
            currowid: null,
            doApply: Apply,
        });
        function Apply(e, mode) {
            fnc.current.searchlistclose();
            var newssdno = [];
            if (!isEmpty(ssdnos)) {
                newssdno =[...ssdnos];
            }
            var addno = [];
            for (let i = 0; i < e.items.length; i++) {
                let data = e.items[i];
                if (!newssdno.includes(data["SSD_NO"])) {
                    newssdno.push(data["SSD_NO"]);
                    addno.push(data["SSD_NO"]);
                }
            }
            setssdnos(newssdno);
            if (addno.length === 0) return;
            //追加加工指示情報取得
            AddSSDInfo(addno);
        }
    }
    function AddSSDInfo(addno) {
        fnc.current.postaxios('rawsupplyinbulk/SSDInfoGet', { keys: addno },
            {
                onSuccess: function (data) {
                    if (isEmpty(detailRef.current)) detailRef.current = [];
                    var total = GridData(G_id.TOTAL);
                    for (let i = 0; i < data.rowdata.length; i++) {
                        for (let j = 0; j < total.length; j++) {
                            var newrow = { ...total[j], ...data.rowdata[i] };
                            detailRef.current.push(newrow);
                        }
                    }
                    if (selectssdno === "") {
                        DispInfoSelectSSD(addno[0], detailRef.current);
                    }
                    fnc.current.wait(false);
                },
            }
        )
    }
    //加工指示データ削除
    function deletessd() {
        if (isEmpty(selectssdno)) return;
        if (!deletecheck()) {
            fnc.current.warnmsg("原材料仕入に紐づいた加工指示番号の為削除できません");
            return;
        }
        let msg = "表示中の加工指示データを削除します。よろしいですか？";
        fnc.current.confmsg(msg, () => exec());
        function exec() {
            var newssd = ssdnos.filter(e => e !== selectssdno);
            setssdnos([...newssd]);
            if (newssd.length === 0) {
                extextfields.forEach((f)=>{
                    entrydataRef.current[f.columnid] = "";
                    if (Object.hasOwn(entrydataRef.current, f.columnid + "_nm")) {
                        entrydataRef.current[f.columnid + "_nm"] = "";
                    }
                });
                setselectssdno('');
                detailRef.current = [];
                SetGridData(G_id.MEI, null);
            } else {
                var newdata = detailRef.current.filter(e => e["ZSK_SSDNO"] !== selectssdno && !isEmpty(DicVal(e, "ZSK_SSDNO")));
                detailRef.current = [...newdata];
                setselectssdno(newssd[0]);
                DispInfoSelectSSD(newssd[0], detailRef.current);
            }
            TotalCalc();
        }
        function deletecheck(){
            if (isEmpty(siiressdRef.current)) return true;
            return !siiressdRef.current.includes(selectssdno);
        }
    }

    //パネル別列情報取得
    function tabletype(id) {
        let pnl = panel.find(e => e.id === id);
        if (isEmpty(pnl)) return '';
        return pnl.type;
    }
    function isSozai() {
        return entrydataRef.current["ZSK_ZAIRYOKBN"] === "1";
    }

    //Basic Data Change
    function ValueChanged(id, value, edit) {
        //外部からの参照がある項目
        let col = columninfo.find(e => e.columnid === id);
        if (!isEmpty(col)) {
            if (col.extriggerref) {
                dispatch(entrytriggercall(id));
            }
        }
    }
    function ChangeRowValue(params, panel) {
        if (params.column.colDef.colinfo.datatype !== CELLTYPE.NUM) {
            return;
        }
        var rowdata = GridData(panel).find(e => e.rowid === params.data.rowid);
        if (entrydataRef.current["ZSK_TSUKATANI"] !== "JPY" && params.column.colId === "ZSKM_TANKA" && !isEmpty(rowdata)) {
            //外貨単価を取得
            rowdata["ZSKM_TANKAF"] = ExchangePrice(params.newValue, 1);
        }
        if (entrydataRef.current["ZSK_TSUKATANI"] !== "JPY" && params.column.colId === "ZSKM_TANKAF" && !isEmpty(rowdata)) {
            //円単価を取得
            rowdata["KHDM_TANKA"] = ExchangePrice(params.newValue, 0);
        }
        var qty = NumConv(rowdata[isSozai() ? "ZSKM_SIKYUMETERSU" : "ZSKM_SIKYUSU"]);
        if (params.column.colId === "ZSKM_SIKYUMETERSU" || params.column.colId === "ZSKM_SIKYUSU") {
            qty = params.newValue;
        }
        var price = NumConv(rowdata["ZSKM_TANKA"]);
        if (params.column.colId === "ZSKM_TANKA") {
            price = params.newValue;
        }
        //金額再計算
        if (entrydataRef.current["ZSK_TSUKATANI"] !== "JPY") {
            var pricef = NumConv(rowdata["ZSKM_TANKAF"]);
            if (params.column.colId === "ZSKM_TANKAF") {
                pricef = params.newValue;
            }
            rowdata["ZSKM_KINGAKUF"] = calcamount(qty, pricef, 1);
        } else {
            rowdata["ZSKM_TANKAF"] = 0;
            rowdata["ZSKM_KINGAKUF"] = 0;
        }
        rowdata["ZSKM_KINGAKU"] = calcamount(qty, price, 0);
        if (DicVal(entrydataRef.current, "ZSK_TAXCD") === "9" && DicVal(entrydataRef.current, "ZSK_SIKYUKBN") === "1") {
            //税分類が内税 "9" かつ支給区分が有償 "1"　※たぶん0
            var dTax = 0;
            if (NumConv(rowdata["TAXRATE"] !== 0)){
                dTax = rowdata["ZSKM_KINGAKU"] / (1 + rowdata["TAXRATE"] / 100) * rowdata["TAXRATE"] / 100
                dTax = GetRound(dtax, 0);
            }
            rowdata["ZSKM_KINGAKUZ"] = rowdata["ZSKM_KINGAKU"] - dTax;
        } else {
            rowdata["ZSKM_KINGAKUZ"] = rowdata["ZSKM_KINGAKU"];
        }
        fnc.current.rerenderGrid(fnc.current.GridID(G_id.MEI));
        storeRowData();
        TotalCalc();
    }
    //金額計算
    function calcamount(qty, price, mode) {
        var amt = NumConv(qty) * NumConv(price);
        if (mode === 0) {   //円
            return GetRound(amt, 0);
        } else {            //外貨
            return GetDesitRound(amt, 0, 2);
        }
    }

    //外貨→円、円→外貨変換
    function ExchangePrice(price, mode) {
        var rate = NumConv(entrydataRef.current["ZSK_SHANAIRATE"]);
        if (mode === 0) {   //外貨→円
            return GetRound(rate * price, 1);
        } else {            //円→外貨
            return GetDesitRound(price / rate, 1, 2);
        }
    }

    //合計算出表示
    function TotalCalc() {
        var totalrows = GridData(G_id.TOTAL);
        totalrows.forEach((t) =>
        {
            var total = detailRef.current.filter(item => item["ZSKM_ZAIHINBAN"] === t["ZSKM_ZAIHINBAN"] && item["ZSKM_ZAICOLORCD"] === t["ZSKM_ZAICOLORCD"])
                .reduce(
                    (sum, item) => {
                        sum.ZSKM_SIKYUSU += Number(item.ZSKM_SIKYUSU) || 0;
                        sum.ZSKM_SIKYUMETERSU += Number(item.ZSKM_SIKYUMETERSU) || 0;
                        sum.ZSKM_KINGAKU += Number(item.ZSKM_KINGAKU) || 0;
                        sum.ZSKM_KINGAKUZ += Number(item.ZSKM_KINGAKUZ) || 0;
                        return sum;
                    },
                    { ZSKM_SIKYUSU: 0, ZSKM_SIKYUMETERSU: 0, ZSKM_KINGAKU: 0, ZSKM_KINGAKUZ: 0 }
            );
            if (isSozai()) {
                t["TOTALQTY"] = total["ZSKM_SIKYUMETERSU"];
            } else {
                t["TOTALQTY"] = total["ZSKM_SIKYUSU"];
            }
            t["RESTQTY"] = Number(t["QTY"]) - t["TOTALQTY"];
            t["ZSKM_KINGAKU"] = total["ZSKM_KINGAKU"];
            t["ZSKM_KINGAKUZ"] = total["ZSKM_KINGAKUZ"];
        });
        fnc.current.rerenderGrid(fnc.current.GridID(G_id.TOTAL));
    }


    //明細編集セル制御
    function RowlockCell(params, edit, status, tabvalue) {
        if (params.colDef.colId === "ZSKM_TANKAF") {
            return entrydataRef.current["ZSK_TSUKATANI"] !== "JPY";
        }
        return edit;
    }

    //panel入れ替え
    const onPanelSortEnd = ({ oldIndex, newIndex }) => {
        let items = panel.filter(e => !panelhidden(e));
        let oldidx = panel.findIndex(e => e.type === items[oldIndex].type);
        let newidx = panel.findIndex(e => e.type === items[newIndex].type);
        setpanel(arrayMove(panel, oldidx, newidx));
    };

    //パネルセレクタ
    function panelnavwidth() {
        return windowDimensions.width - 280;
    }
    const SortablePanelItem = SortableElement(({ pnl }) => (
        <ListItem className="minwidth0">
            <Chip
                label={pnl.name}
                title={pnl.name}
                size="small"
                onClick={() => Jump(pnl.id, pnl.type)}
            />
        </ListItem>
    ));
    const SortablePanelSelector = SortableContainer(({ items }) => {
        var newitem = [];
        for (let i = 0; i < items.length; i++) {
            if (!panelhidden(items[i])) newitem.push(items[i]);
        }
        return (
            <ul style={{ display: 'flex' }}  >
                {newitem.map((value, index) => (
                    <SortablePanelItem key={`item-${index}`} index={index} pnl={value} />
                ))}
            </ul>
        );
    });

    function Contents(props) {
        if (props.panel.id === G_id.BASE) {
            const baseid = "basepanel" + props.panel.type;
            return (
                <div id={baseid} >
                    <EntryBase
                        fnc={fnc}
                        textfields={textfields}
                        settextfields={settextfields}
                        panel={props.panel}
                        ValueChanged={ValueChanged}
                        entrydataRef={entrydataRef}
                        layoutlock={layoutlock}
                    />
                </div>
            );
        }
        if (props.panel.id === G_id.IMAGE) {
            return (
                <EntryImages
                    fnc={fnc}
                    controller={controller}
                    code={edittingcode}
                    dataRef={imageRef}
                    rerender={rerender}
                />
            )
        }
        if (props.panel.id === G_id.MEI ) {  //加工指示別
            const gridRefs = GridRefs(props.panel);
            return (
                <React.Fragment>
                    <Box sx={{ width: '80%', bgcolor: 'background.paper' }}>
                        {ssdnos === null ? <div style={{ height: 32 }}> ... 加工指示番号未選択</div> :
                            <Tabs
                                value={selectssdno}
                                onChange={handleChange}
                                variant="scrollable"
                                scrollButtons="auto"
                                TabIndicatorProps={{
                                    style: { display: 'none' },
                                }}
                                sx={{
                                    minHeight: 32,
                                    height: 32,

                                    '& .MuiTab-root': {
                                        minHeight: 32,
                                        height: 32,
                                        padding: '4px 12px',
                                        fontSize: 13,
                                        borderRadius: 1,
                                    },

                                    '& .MuiTab-root.Mui-selected': {
                                        backgroundColor: '#d6ebff',
                                        color: '#1976d2',
                                    },
                                }}
                            >

                                {ssdnos.map(tab => (
                                    <Tab
                                        key={tab}
                                        value={tab}
                                        label={tab}
                                    />
                                ))}
                            </Tabs>
                        }
                    </Box>
                    <div id={"basepanelex2"} >
                        <EntryBase
                            fnc={fnc}
                            textfields={extextfields}
                            settextfields={setextextfields}
                            panel={{ id: "ex2", "type": "121" }}
                            entrydataRef={entrydataRef}
                            layoutlock={layoutlock}
                        />
                    </div>
                    {!isEmpty(gridRefs) &&
                        <EntryGridAr
                            id={fnc.current.GridID(props.panel)}
                            entrydataRef={entrydataRef}
                            dataRef={gridRefs.dataRef}
                            columnRef={gridRefs.columnRef}
                            columninfo={columninfo}
                            columns={columns}
                            fnc={fnc}
                            onFirstDataRendered={onFirstDataRendered}
                            formid={formid}
                            ValueChanged={(e) => ChangeRowValue(e, props.panel)}
                            panel={props.panel}
                            EntrybodyRef={EntrybodyRef}
                            rowContext={1}
                            rowDragManaged={false}      //並び替え不可
                            lockcell={RowlockCell}
                       />
                    }
                </React.Fragment>
            );
        }
        if (props.panel.id === G_id.TOTAL) {  //合計
            const gridRefs = GridRefs(props.panel);
            if (isEmpty(gridRefs)) return null;
            return (
                <EntryGridAr
                    id={fnc.current.GridID(props.panel)}
                    entrydataRef={entrydataRef}
                    dataRef={gridRefs.dataRef}
                    columnRef={gridRefs.columnRef}
                    columninfo={columninfo}
                    columns={columns}
                    fnc={fnc}
                    onFirstDataRendered={onFirstDataRendered}
                    formid={formid}
                    panel={props.panel}
                    EntrybodyRef={EntrybodyRef}
                />
            );
        }
        if (props.panel.id === G_id.FILE) {
            return (
                <EntryFiles
                    fnc={fnc}
                    controller={controller}
                    code={edittingcode}
                    dataRef={fileRef}
                    rerender={rerender}
                />
            )
        }
        if (props.panel.id === G_id.NB) {
            if (isEmpty(columninfo)) return null;
            let coldef = columninfo.find(e => e.type === props.panel.type);
            return (
                <EntryRemarks
                    id={"remarkspanel" + props.panel.type}
                    def={coldef}
                    dataRef={entrydataRef}
                    fnc={fnc}
                    ValueChanged={ValueChanged}
                />
            )
        }
        return null;

    }
    function EmptyPanel(id, type) {
        try {
            if (!panel.some(e => e.id === id)) return true; //パネル定義なし
            if (!isEmpty(type)) {
                if (!panel.some(e => e.id === id && e.type === type)) return true; //パネル定義なし
            }
            if (id === G_id.BASE) return isEmpty(textfields.find(e => e.type === type));
            let tbltype = tabletype(id);
            return !columns.some(e => e.type === tbltype);
        } catch { }
        return false;
    }
    function panelhidden(p) {
        if (isEmpty(p)) return false;
        if (p.id === G_id.IMAGE) {
            if (isEmpty(imageRef.current)) return true;
            if (imageRef.current.length === 0) return true;
            return p.hide;
        }
        if (p.id === G_id.FILE) {
            if (isEmpty(fileRef.current)) return true;
            if (fileRef.current.length === 0) return true;
            return p.hide;
        }
        if (EmptyPanel(p.id, p.type)) return true;
        return p.hide;
    }

    function EntryForm() {
        return (
            <div style={{ padding: '5px 15px', paddingBottom: '300px', height: '100%', overflow: 'auto', backgroundColor: '#D8D8D8' }} ref={EntrybodyRef} onDragEnter={onDragEnter}>
                {panel.map((p,i) => {
                   return (
                        <Box
                           display={panelhidden(p) ? "none" : "flex"}
                           justifyContent="space-around"
                           alignItems="center"
                           padding="5px"
                            >
                            <Paper
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    padding: 10
                                }}
                           >
                               <div style={{ position: 'relative', marginBottom: 5 }}>
                                   {p.name} - <span style={{ fontStyle: 'oblique' }}>{p.name2}</span>
                                   {p.id !== '0' || layoutlock ? null :
                                       <div style={{ position: 'absolute', right: 40, top: -3 }} title="項目設定">
                                           <IconButton size="small" onClick={()=>SetBaseField(p.type)}  >
                                               <Icon style={{ fontSize: 16 }}>settings_applications</Icon>
                                           </IconButton>
                                       </div>
                                   }
                                   {layoutlock || sectionclose ? null :
                                       <div style={{ position: 'absolute', right: 10, top: -3 }}>
                                           <IconButton size="small" onClick={() => showpanel(p.id, p.type, false)}  >
                                               <Icon style={{ fontSize: 16 }}>close</Icon>
                                           </IconButton>
                                       </div>
                                   }
                                   {p.id !== '2' ? null :
                                        <React.Fragment>
                                        {ssdnos === null ? null :
                                            <div style={{ position: 'absolute', right: 150, top: 15 }}>
                                                <Button size="small" onClick={deletessd}
                                                    style={{
                                                        width: 100, backgroundColor: "#BABBAB", color: '#FFF', fontWeight: 700, marginRight: 20
                                                    }}
                                                >
                                                    加工指示削除
                                                </Button>
                                            </div>
                                        }
                                       <div style={{ position: 'absolute', right: 30, top: 15 }}>
                                           <Button size="small" onClick={showssdlist}
                                               style={{
                                                   width: 100, backgroundColor: "#BABBAB", color: '#FFF', fontWeight: 700, marginRight: 20
                                               }}
                                           >
                                               加工指示選択
                                           </Button>
                                       </div>
                                    </React.Fragment>
                                   }
                               </div>
                                     <Contents panel={p}/>
                                </Paper >
                           </Box>
                    );
                })}
            </div>
        );
    }
    return (
        <div>
            <ComFunc ref={fnc} />
            <MasterBase
                ref={baseref}
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                entrycallback={MenuAction}
                entryform={true}
                entryonly={true}
           >
            <EntryForm/>
            </MasterBase>
            <EntryLayout
                 columninfo={textfieldsall}
                 textfields={textfields} 
                 onAppry={SetLayout}
            />
            {formstatus === 'NEW FORM' || formstatus === 'ENTRY FORM' || formstatus === 'COPY FORM' ?
                <div>
                    <div style={{ position: 'absolute', top: 60, right: 15 }}>
                        <IconButton size="small" onClick={() => fnc.current.entrysettingopen()} title={"レイアウト設定"} >
                            <Icon>table_chart</Icon>
                        </IconButton>
                    </div>
                    <Headline columninfo={columninfo} entrydata={entrydataRef.current} ></Headline>
                    <div style={{ position: 'absolute', top: 60, left: 210 }}>
                    <Paper
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            flexWrap: 'wrap',
                            listStyle: 'none',
                            p: 0.5,
                            m: 0,
                        }}
                        component="ul"
                        elevation={0}
                        style={{ backgroundColor: "transparent", width: panelnavwidth() }}
                    >
                            {/*Panel Selector*/}
                            <SortablePanelSelector
                                axis={"x"}
                                items={panel}
                                onSortEnd={onPanelSortEnd}
                                distance={2}
                             />
                    </Paper>
                    </div>
                </div>
                : null}
            <AGFunc ref={AGRef} />
            <EntrySetting
                formid={formid}
                controller={controller}
                subkey={subkey}
                savelayout={SaveLayout}
                deletelayout={DeleteLayout}
                calllayout={CallLayout}
                panels={panel}
                showpanel={showpanel}
            />
        </div>
    );
};

